import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import Header from 'component/layouts/Header'

function Public(ComposedComponent, renderHeader = true) {
  class PublicComponent extends Component {
    static propTypes = {
      auth: PropTypes.object.isRequired,
      translate: PropTypes.func,
      dispatch: PropTypes.func,
      location: PropTypes.object.isRequired,
    }

    componentWillMount() {
      const { auth } = this.props

      this.checkAuth(auth.isAuthenticated)
    }

    componentWillUpdate(nextProps) {
      this.checkAuth(nextProps.auth.isAuthenticated)
    }

    checkAuth(isAuthenticated) {
      const { dispatch, location } = this.props
      const { pathname } = location

      if (isAuthenticated && pathname !== '/privacy') {
        dispatch(push('/'))
      }
    }

    render() {
      const { auth, translate } = this.props

      return (
        <div>
          {renderHeader && <Header auth={auth} translate={translate} />}
          <ComposedComponent {...this.props} />
        </div>
      )
    }
  }

  const mapStateToProps = (state) => ({
    auth: state.auth,
  })

  return connect(mapStateToProps)(PublicComponent)
}

export default Public
